import { apiClient } from '../../../v4/core/apiClient';
import { createEnterpriseApi } from './enterprise.api.http';

export const myEnterpriseApi = createEnterpriseApi(apiClient);
